import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface RejectReasonModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onClick: () => void;
  setReason: Dispatch<SetStateAction<string>>;
  reason: string;
}

export default function RejectReasonModal({
  open,
  onClose,
  setOpen,
  onClick,
  setReason,
  reason,
}: RejectReasonModalProps) {
  return (
    <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Are you sure want to reject?</h2>
            <div role="button" tabIndex={0} className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <TextField
                placeholder="Enter reason"
                fullWidth
                hiddenLabel
                type="text"
                multiline
                maxRows={5}
                minRows={5}
                value={reason}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                  } else {
                    setReason(val.target.value);
                  }
                }}
              />
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={onClick}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
